<span class="badge" [ngClass]="className">
  <vtmn-play-icon
    *ngIf="icon"
    [name]="icon"
    [width]="18"
    [height]="18"
    class="badge__icon"
    [ngClass]="iconClass"
  ></vtmn-play-icon>
  <ng-content></ng-content>
</span>
